<style lang="scss">
#client-location {
  .table-form-control {
    width: 100px !important;
    float: right;
  }
}
#client-service {
  input[type="file"] {
    display: none;
  }
}
.custom-file-upload {
  padding: 6px 12px;
  cursor: pointer;
  background: #1bc5bd;
  color: white !important;
  border-radius: 3px;
}
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex-center input[type="checkbox"] {
  margin-right: 0.5rem;
}
</style>

<template>
  <div class="row" id="client-location">
    <div class="col-md-12">
      <div class="card form-body">
        <div class="card-body">
          <form action="">
            <div class="row">
              <div class="col-md-12">
                <legend v-if="!isEdit"><h5>Create Notification</h5></legend>
                <legend v-else><h5>Edit Notification</h5></legend>
                <hr />

                <!-- <div class="form-group">
                  <label for="description"
                    >Description <span class="text-danger">*</span></label
                  >
                  <textarea
                    name="description"
                    id=""
                    cols="30"
                    rows="1"
                    class="form-control"
                    v-model="formData.description"
                    :class="errors['description'] ? 'border border-danger' : ''"
                  ></textarea>
                  <span v-if="errors['description']" class="text-danger">{{
                    errors["description"][0]
                  }}</span>
                </div> -->

                <div class="row">
                  <hr />
                  <div class="form-group col-md-6">
                    <label for="title"
                      >Title/Subject <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      name="title"
                      class="form-control"
                      v-model="title"
                      :class="errors['title'] ? 'border border-danger' : ''"
                    />
                    <span v-if="errors['title']" class="text-danger">{{
                      errors["title"][0]
                    }}</span>
                  </div>
                  <div class="form-group col-md-3">
                    <label for="visible_from"
                      >Visible From <span class="text-danger">*</span></label
                    >
                    <input
                      type="date"
                      name="visible_from"
                      class="form-control"
                      v-model="visible_from"
                      :class="
                        errors['visible_from'] ? 'border border-danger' : ''
                      "
                    />
                    <span v-if="errors['visible_from']" class="text-danger">{{
                      errors["visible_from"][0]
                    }}</span>
                  </div>
                  <div class="form-group col-md-3">
                    <label for="visible_from"
                      >Visible Until <span class="text-danger">*</span></label
                    >
                    <input
                      type="date"
                      name="visible_until"
                      class="form-control"
                      v-model="visible_until"
                      :class="
                        errors['visible_until'] ? 'border border-danger' : ''
                      "
                    />
                    <span v-if="errors['visible_until']" class="text-danger">{{
                      errors["visible_until"][0]
                    }}</span>
                  </div>
                </div>
                <div class="row">
                  <hr />
                  <div class="form-group col-md-6">
                    <div class="form-group">
                      <label for="">
                        Service Providers<span class="text-danger">*</span>
                      </label>
                      <multiselect
                        :value="clients"
                        :options="getserviceProviders"
                        :show-labels="true"
                        label="name"
                        track-by="id"
                        :close-on-select="false"
                        class="custom-notification-multiselect"
                        :multiple="true"
                        @input="selectClients"
                      />
                      <span v-if="errors['clients']" class="text-danger">{{
                      errors["clients"][0]
                    }}</span>

                    <div style="display: flex; align-items: center; justify-content: space-between;">
                      <div style="display: flex; align-items: center;">
                        <input
                          type="checkbox"
                          id="all_service_provider"
                          v-model="all_service_provider"
                          @change="allServiceProviderSelected"
                          style="transform: scale(1.5); margin-right: 5px; width: 10px; height: 30px;"
                        />
                        <label for="all_service_provider"
                        style="margin-bottom: 0px !important;"
                          >Select All Service Provider</label
                        >
                      </div>
                      <div style="cursor: pointer; color: rgb(214 73 73); font-weight: 500;" class="notification-multiselect-clear-button" @click="clearAllServiceProvider()" v-if="clients.length > 0">
                        Clear
                      </div>
                    </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <div class="form-group">
                      <label for="">
                        Service Locations<span class="text-danger">*</span>
                      </label>
                      <multiselect
                        :value="locations"
                        :options="getSelectedProviderLocations"
                        :show-labels="true"
                        label="name"
                        class="custom-notification-multiselect"
                        track-by="id"
                        :multiple="true"
                        :close-on-select="false"
                        @input="(val) => (locations = val)"
                      />
                      <span v-if="errors['locations']" class="text-danger">{{
                      errors["locations"][0]
                    }}</span>

                    <div style="display: flex; align-items: center; justify-content: space-between;">
                      <div style="display: flex; align-items: center;">
                        <input 
                          type="checkbox"
                          id="all_locations"
                          v-model="all_locations"
                          @change="allLocationSelected"
                          style="transform: scale(1.5); margin-right: 5px; width: 10px; height: 30px;"
                        />
                        <label for="all_locations"
                        style="margin-bottom: 0px !important;"
                          >Select All Service Locations</label
                        >
                      </div>
                      <div style="cursor: pointer; color: rgb(214 73 73); font-weight: 500;" class="notification-multiselect-clear-button" @click="() => {locations = []; all_locations = false;}" v-if="locations.length > 0">
                          Clear
                        </div>
                    </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-2">
                    <label>Send on Email</label>
                    <span class="switch">
                      <input
                        type="checkbox"
                        v-model="send_to_email"
                        class="switch"
                        id="switch-send_to_email"
                      />
                      <label for="switch-send_to_email"></label>
                    </span>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Is Urgent</label>
                    <span class="switch">
                      <input
                        type="checkbox"
                        v-model="is_urgent"
                        class="switch"
                        id="urgent-switch"
                      />
                      <label for="urgent-switch"></label>
                    </span>
                  </div>
                </div>
                <h6>Description</h6>
                
                <div class="form-group">
                  <supporteditor
                    v-model="details"
                    api-key="no-api-key"
                    :init="{
                      license_key: 'gpl',
                      height: 200,
                      menubar: false,
                      plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount',
                      ],
                      toolbar:
                        'undo redo | formatselect | bold italic backcolor | \
                        alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat | help',
                    }"
                    tinymce-script-src="/tinymce/js/tinymce/tinymce.min.js"
                  />
                  <span v-if="errors['details']" class="text-danger">{{
                      errors["details"][0]
                    }}</span>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="card-footer">
          <button
            v-if="isEdit"
            class="btn btn-success"
            @click="createNotification()"
            style="float: right"
            ref="kt_update_service"
          >
            <i class="fa fa-check"></i>Update
          </button>
          <button
            v-if="!isEdit"
            class="btn btn-success ml-3"
            style="float: right"
            ref="store_s"
            @click="createNotification()"
          >
            <i class="fa fa-check"></i>Save
          </button>
          <!-- <button
            v-if="!isEdit"
            class="btn btn-success"
            style="float: right"
            @click="store('SAA', 'store_ssa')"
            ref="store_ssa"
          >
            <i class="fa fa-check"></i>Save and Add Another
          </button> -->
          <button
            ref="kt_save_add_another_company"
            class="btn btn-danger mr-3"
            @click="goBack()"
            style="float: right"
          >
            <i class="fa fa-arrow-left"></i> Back
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import Editor from "@tinymce/tinymce-vue";
import Multiselect from "vue-multiselect";

import {
  GET_SERVICE_PROVIDER_LIST,
  CREATE_UPDATE_NOTIFICATION,
  FETCH_NOTIFICATIONS,
  FETCH_SELECTED_LOCATIONS
} from "@/core/services/store/actions.type";
import { mapGetters } from "vuex";

export default {
  params: {
    notification: {
      type: Number,
      default: () => ({}),
    },
  },
  data() {
    return {
      isEdit: false,
      breadCrumbs: [
        {
          id: 1,
          title: "Dashboard",
          route: "admin.dashboard",
        },
        {
          id: 2,
          title: "Notification",
          route: "admin.notification",
        },
        {
          id: 3,
          title: "Create Notification",
          route: "",
        },
      ],
      details: "",
      title: "",
      send_to_email: false,
      is_urgent: false,
      loading_data: true,
      errors: [],
      clients: [],
      locations: [],
      visible_from: "",
      visible_until: "",
      all_service_provider: false,
      all_locations: false,
      id: 0,
      locations: [],
    };
  },
  computed: {
    ...mapGetters(["getserviceProviders", "getSelectedProviderLocations"]),
  },
  components: {
    supporteditor: Editor,
    Multiselect,
  },
  created() {
    if (this.getserviceProviders.length == 0) {
      this.getServiceProvider();
    }
    if (this.$route.params.notification_id != undefined) {
      this.fetchEditNotification(this.$route.params.notification_id);
      this.isEdit = true;
      // this.notificationData = this.$route.params.notification;
    }
    this.timeZones = this.$moment.tz.names();
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    if (this.isEdit) {
      this.breadCrumbs[2].title = "Edit Notification";
    }
  },
  mounted() {
    if (!this.isEdit) {
      this.visible_until = this.$moment(new Date())
        .add(7, "days")
        .format("YYYY-MM-DD");
      this.visible_from = this.$moment(new Date()).format("YYYY-MM-DD");
    }
  },
  methods: {
    selectClients(selected) {
      this.clients = selected;
      this.all_service_provider = false
      this.locations = this.locations.filter(location =>
        this.clients.some(client => client.id === location.parent)
      );
      this.getSelectedLocations(this.clients.map(e => e.id));
      this.all_locations = false;
    },
    clearAllServiceProvider() {
      this.clients = [];
      this.all_service_provider = false;
      this.locations = [];
      this.all_locations = false;
      this.getSelectedLocations(this.clients.map(e => e.id));
    },
    getServiceProvider() {
      this.loadingData = true;
      this.$store
        .dispatch(GET_SERVICE_PROVIDER_LIST)
        .then((res) => {
          if (res.code == 200) {
            this.url = res.url;
          }
          this.loadingData = false;
        })
        .catch((err) => {
          this.loadingData = false;
          this.msg = err.error;
        });
    },
    getSelectedLocations(e, selected_data = []){
      console.log(e, selected_data);
      this.loading_data = true;
      this.$store.dispatch(FETCH_SELECTED_LOCATIONS, e)
      .then((res) => {
        if(this.isEdit && selected_data.length > 0){
          setTimeout(() => {
            console.log(this.getSelectedProviderLocations, selected_data);
            this.locations = this.getSelectedProviderLocations.filter(location =>
              selected_data.some(l => l.client === location.id)
            );
            console.log(this.locations);
          }, 500);
        }
        this.loadingData = false;
      })
    .catch((err) => {
      this.loadingData = false;
      this.msg = err.error;
    });
  },

    goBack() {
      this.$router.push({
        name: "admin.notification",
      });
    },
    allServiceProviderSelected() {
      if (this.all_service_provider) {
        this.clients = this.getserviceProviders;
        this.all_locations = false;
        this.getSelectedLocations(this.clients.map(e => e.id));
      }
    },
    allLocationSelected() {
      if (this.all_locations) {
        this.locations = this.getSelectedProviderLocations;
      }
    },
    fetchEditNotification(notification_id) {
      this.loading_data = true;
      this.$store
        .dispatch(FETCH_NOTIFICATIONS, { id: notification_id })
        .then((res) => {
          if (res.success == true) {
            const data = res.data[0];
            this.visible_until = data.visible_until;
            this.visible_from = data.visible_from;
            this.details = data.details;
            this.send_to_email = data.send_to_email;
            this.is_urgent = data.is_urgent;
            this.title = data.title;
            this.id = data.id;
            
            setTimeout(() => {
              this.clients = this.getserviceProviders.filter(provider =>
                data.clients.some(c => c.client === provider.id)
              );
              this.getSelectedLocations(this.clients.map(e => e.id), data.locations);
            }, 500);

          setTimeout(() => {
            this.locations = this.getSelectedProviderLocations.filter(location => data.locations.some(l => l.location === location.id));
            },500);
          }
          this.loading_data = false;
        })
        .catch((err) => {
          this.loading_data = false;
          this.msg = err.error;
        });
    },

    createNotification() {
      this.notificationData = {
        title: this.title,
        details: this.details,
        visible_from: this.visible_from,
        visible_until: this.visible_until,
        send_to_email: this.send_to_email,
        is_urgent: this.is_urgent,
        clients: this.all_service_provider
        ? this.getserviceProviders.map(p => p.id)
        : this.clients.map(c => c.id),
        id: this.id,
        locations: this.all_locations
        ? this.getSelectedProviderLocations.map(l => l.id)
        : this.locations.map(l => l.id),
      };
      this.loadingData = true;
      this.$store
        .dispatch(CREATE_UPDATE_NOTIFICATION, this.notificationData)
        .then((res) => {
          this.loadingData = false;
          this.$toastr.s(res.msg || "Notification created successfully");
          this.$router.push({
            name: "admin.notification",
          });
        })
        .catch((err) => {
          this.loadingData = false;
          this.errors = err.error;
          this.$toastr.e(err.msg || "Error creating notification");
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
input[type="number"] {
  -moz-appearance: textfield !important;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.cropper {
  height: 600px;
  background: #ddd;
}

.custom-notification-multiselect.multiselect--disabled {
  pointer-events: unset !important;
}

.custom-notification-multiselect.multiselect--disabled .multiselect__tags{
  pointer-events: none !important;
}
.notification-multiselect-clear-button:hover {
  text-decoration: underline;
}
</style>

<style>
.custom-notification-multiselect.multiselect .multiselect__tags {
  max-height: 100px !important;
  overflow-x: hidden;
  overflow-y: auto;
}
.custom-notification-multiselect.multiselect--disabled .multiselect__select {
  background-color: transparent !important;
}
</style>